export function useDocumentTitle(base: string, subtitle?: string) {
    const setTitle = (text?: string) => {
        document.title = text ? `${text} | ${base}` : `${base}`;
    };

    if (subtitle) setTitle(subtitle);

    return { setTitle };
}
